import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithApple } from '../lib/apple.js';
import { loginWithApple, getToken } from '../lib/api.js';

export default function Login() {
  const nav = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [pwaHint, setPwaHint] = useState(false);

  useEffect(() => {
    if (getToken()) nav('/', { replace: true });
    // If user is on iOS Safari but not in standalone PWA mode, hint to install.
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isStandalone = window.navigator.standalone === true;
    if (isIOS && !isStandalone) setPwaHint(true);
  }, []);

  async function handleSignIn() {
    setLoading(true);
    setError('');
    try {
      const { idToken, user } = await signInWithApple();
      await loginWithApple(idToken, user);
      nav('/', { replace: true });
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }

  return (
    <div className="login-screen">
      <div className="hero">Velkra Distribution</div>
      <div className="tagline">Beta builds for ByteFlow Apps testers</div>

      {error && <div className="error-banner" style={{ maxWidth: 320, marginBottom: 16 }}>{error}</div>}

      {/*
        HIG-compliant Sign in with Apple button.
        - Black background, white "Continue with Apple" text + logo
        - 44pt minimum touch target (we use 48px)
        - Uses Apple's official logo asset — must be downloaded from
          Apple Design Resources (https://developer.apple.com/design/resources/)
          and placed at /icons/apple-logo-white.svg before this button
          renders correctly. The asset shipped here is the official path
          from Apple's "Sign in with Apple Buttons" download.
        - Always renders the Apple logo + approved title text per HIG.
      */}
      <button
        type="button"
        className="apple-signin-btn"
        onClick={handleSignIn}
        disabled={loading}
        aria-label="Sign in with Apple"
      >
        {loading ? (
          <span className="apple-signin-btn__loading">Signing in…</span>
        ) : (
          <>
            <img
              src="/icons/apple-logo-white.svg"
              alt=""
              aria-hidden="true"
              className="apple-signin-btn__logo"
              width="16"
              height="19"
            />
            <span className="apple-signin-btn__label">Sign in with Apple</span>
          </>
        )}
      </button>

      {pwaHint && (
        <div style={{ maxWidth: 320, marginTop: 24, padding: 14, background: 'var(--bg-elev)',
                      borderRadius: 12, fontSize: 13, color: 'var(--text-muted)', textAlign: 'left' }}>
          <strong style={{ color: 'var(--text)' }}>Install for full features</strong><br/>
          For build notifications, tap Share → <em>Add to Home Screen</em>, then open from your Home Screen.
        </div>
      )}

      <div style={{ marginTop: 32, fontSize: 13, color: 'var(--text-muted)' }}>
        Need access? Ask your admin to invite your Apple ID email.
      </div>
    </div>
  );
}
